export const demoConfig = {
  API: {
    ROOT_URL: () => 'https://apidemoa.econsulttest.health',
    IE_ROOT_URL: () => 'https://demo.webgp.com/cors-es',
    SUBMISSION_URL: () => 'https://demo.webgp.com/api/consultation/submitsession',
    POSTCODE_URL: (practiceId, postcode) => `https://demo.webgp.com/findMatchingPostcodes/${postcode}`,
    ADDRESSES_URL: (practiceId, postcode) => `https://demo.webgp.com/searchPostcode/${postcode}`,
  },
  S3_BUCKET: `https://s3.eu-west-2.amazonaws.com/test.frontend.econsult.health/especialist-frontend/${process.env.REACT_APP_VERSION}/build`,
  SESSION_TIMEOUT: {
    IN_MINUTES: 20,
  },
  DEV_LOGIN_ENABLED: false,
};
